<template>
  <div class="page-loader" v-if="isloaded">


<svg xmlns="http://www.w3.org/2000/svg" width="153.1300048828125" height="30.47800064086914" viewBox="0 0 153.13 30.478">
  <g id="Raggruppa_197" data-name="Raggruppa 197" transform="translate(1127 124)">
    <g id="_119-logo-vistosi" data-name="119-logo-vistosi" transform="translate(-1127 -124)">
      <g id="Raggruppa_195" data-name="Raggruppa 195" transform="translate(0 0.279)">
        <path id="Tracciato_188" data-name="Tracciato 188" d="M48.969,17.713a.577.577,0,0,1-1,.578L41.522,9.043a4.389,4.389,0,0,0-7.33.463L27.668,20.524a3.069,3.069,0,0,1-5.281-3.13L28.227,6.36a7.356,7.356,0,0,1,6.788-3.669A7.229,7.229,0,0,1,41.27,6.3l7.7,11.408" transform="translate(-14.219 -2.691)" fill="#20221e" class="svg-elem-1"></path>
        <path id="Tracciato_189" data-name="Tracciato 189" d="M2.893,32.443a.576.576,0,0,1,1-.578l6.449,9.247a4.389,4.389,0,0,0,7.33-.462l6.525-11.018a3.069,3.069,0,0,1,5.28,3.128L23.633,43.8a7.355,7.355,0,0,1-6.787,3.669,7.227,7.227,0,0,1-6.254-3.613l-7.7-11.408" transform="translate(-2.815 -17.844)" fill="#20221e" class="svg-elem-2"></path>
      </g>
      <g id="Raggruppa_196" data-name="Raggruppa 196" transform="translate(34.828 0)">
        <path id="Tracciato_190" data-name="Tracciato 190" d="M108.473,2.715h6.434L104.843,32.326h-5.9L88.965,2.715H95.6l6.352,22.437h.083Z" transform="translate(-88.965 -2.426)" fill="#20221e" class="svg-elem-3"></path>
        <path id="Tracciato_191" data-name="Tracciato 191" d="M162.767,9.959V31.9h-5.775V9.959Zm0-2.6h-5.775V2h5.775Z" transform="translate(-129.49 -2)" fill="#20221e" class="svg-elem-4"></path>
        <path id="Tracciato_192" data-name="Tracciato 192" d="M189.441,27.521c-.246-1.4-.742-2.887-3.876-2.887s-3.547,1.2-3.547,2.145c0,3.464,13.734.948,13.734,9.032,0,6.393-6.185,7.547-9.609,7.547-4.99,0-10.393-1.733-10.558-7.588h5.939c0,1.856,1.154,3.216,4.783,3.216,2.97,0,3.671-1.442,3.671-2.268,0-3.67-13.611-.907-13.611-9.114,0-3.218,2.021-7.341,8.867-7.341,4.291,0,9.4,1.073,9.857,7.258h-5.65Z" transform="translate(-140.566 -12.88)" fill="#20221e" class="svg-elem-5"></path>
        <path id="Tracciato_193" data-name="Tracciato 193" d="M233.634,12.937h3.589v4.125h-3.589V28.98c0,1.28.041,1.774,2.393,1.774.371,0,.783-.04,1.2-.081v4.371c-.908.041-1.815.083-2.722.083h-.743c-4.99,0-5.9-1.9-5.9-4.743V17.063h-2.969V12.937h2.969V7h5.774Z" transform="translate(-169.939 -4.978)" fill="#20221e" class="svg-elem-6"></path>
        <path id="Tracciato_194" data-name="Tracciato 194" d="M267.141,43.358c-5.9,0-11.217-3.629-11.217-11.547s5.319-11.547,11.217-11.547,11.218,3.628,11.218,11.547S273.039,43.358,267.141,43.358Zm0-18.229c-4.454,0-5.277,3.877-5.277,6.681s.823,6.681,5.277,6.681,5.279-3.877,5.279-6.681S271.6,25.129,267.141,25.129Z" transform="translate(-188.426 -12.88)" fill="#20221e" class="svg-elem-7"></path>
        <path id="Tracciato_195" data-name="Tracciato 195" d="M325.834,27.521c-.246-1.4-.741-2.887-3.876-2.887s-3.547,1.2-3.547,2.145c0,3.464,13.734.948,13.734,9.032,0,6.393-6.186,7.547-9.609,7.547-4.991,0-10.393-1.733-10.558-7.588h5.94c0,1.856,1.154,3.216,4.783,3.216,2.97,0,3.67-1.442,3.67-2.268,0-3.67-13.61-.907-13.61-9.114,0-3.218,2.021-7.341,8.867-7.341,4.29,0,9.4,1.073,9.858,7.258h-5.651Z" transform="translate(-221.818 -12.88)" fill="#20221e" class="svg-elem-8"></path>
        <path id="Tracciato_196" data-name="Tracciato 196" d="M373.081,9.959V31.9h-5.774V9.959Zm0-2.6h-5.774V2h5.774Z" transform="translate(-254.78 -2)" fill="#20221e" class="svg-elem-9"></path>
      </g>
    </g>
  </g>
</svg>



  </div> 
</template>

<script>
  export default {
      name: "PageLoader",
    data: () => {
      return {
        
      }
    },
  computed:{
    isloaded(){
      return this.$store.state.order.isloading;
    }
  }
  }
</script>

<style  scoped>
.page-loader{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:fixed;top:0;left:0;width:100vw;height:100vh;background-color:rgba(51, 51, 51, 0.342);z-index:999}.cube{width:40px;height:40px;margin-right:10px}.cube:nth-child(1){background-color:#8CC271}.cube:nth-child(2){background-color:#69BEEB}.cube:nth-child(3){background-color:#F5AA39}.cube:nth-child(4){background-color:#E9643B}.cube:first-child{-webkit-animation:left 1s infinite;animation:left 1s infinite}.cube:last-child{-webkit-animation:right 1s infinite .5s;animation:right 1s infinite .5s}@-webkit-keyframes left{40%{-webkit-transform:translateX(-60px);transform:translateX(-60px)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes left{40%{-webkit-transform:translateX(-60px);transform:translateX(-60px)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes right{40%{-webkit-transform:translateX(60px);transform:translateX(60px)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes right{40%{-webkit-transform:translateX(60px);transform:translateX(60px)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}
/***************************************************
 * Generated by SVG Artista on 5/20/2022, 3:01:00 PM
 * MIT license (https://opensource.org/licenses/MIT)
 * W. https://svgartista.net
 **************************************************/
/***************************************************
 * Generated by SVG Artista on 5/20/2022, 3:08:03 PM
 * MIT license (https://opensource.org/licenses/MIT)
 * W. https://svgartista.net
 **************************************************/

@-webkit-keyframes animate-svg-fill-1 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

@keyframes animate-svg-fill-1 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

.svg-elem-1 {
  -webkit-animation: animate-svg-fill-1 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 0.8s  both infinite;
          animation: animate-svg-fill-1 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 0.8s  both infinite;
}

@-webkit-keyframes animate-svg-fill-2 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

@keyframes animate-svg-fill-2 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

.svg-elem-2 {
  -webkit-animation: animate-svg-fill-2 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 0.9s  both infinite;
          animation: animate-svg-fill-2 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 0.9s  both infinite;
}

@-webkit-keyframes animate-svg-fill-3 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

@keyframes animate-svg-fill-3 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

.svg-elem-3 {
  -webkit-animation: animate-svg-fill-3 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1s  both infinite;
          animation: animate-svg-fill-3 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1s  both infinite;
}

@-webkit-keyframes animate-svg-fill-4 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

@keyframes animate-svg-fill-4 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

.svg-elem-4 {
  -webkit-animation: animate-svg-fill-4 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.1s  both infinite;
          animation: animate-svg-fill-4 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.1s  both infinite;
}

@-webkit-keyframes animate-svg-fill-5 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

@keyframes animate-svg-fill-5 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

.svg-elem-5 {
  -webkit-animation: animate-svg-fill-5 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.2000000000000002s  both infinite;
          animation: animate-svg-fill-5 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.2000000000000002s  both infinite;
}

@-webkit-keyframes animate-svg-fill-6 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

@keyframes animate-svg-fill-6 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

.svg-elem-6 {
  -webkit-animation: animate-svg-fill-6 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.3s  both infinite;
          animation: animate-svg-fill-6 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.3s  both infinite;
}

@-webkit-keyframes animate-svg-fill-7 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

@keyframes animate-svg-fill-7 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

.svg-elem-7 {
  -webkit-animation: animate-svg-fill-7 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.4000000000000001s  both infinite;
          animation: animate-svg-fill-7 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.4000000000000001s  both infinite;
}

@-webkit-keyframes animate-svg-fill-8 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

@keyframes animate-svg-fill-8 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

.svg-elem-8 {
  -webkit-animation: animate-svg-fill-8 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.5s  both infinite;
          animation: animate-svg-fill-8 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.5s  both infinite;
}

@-webkit-keyframes animate-svg-fill-9 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

@keyframes animate-svg-fill-9 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(32, 34, 30);
  }
}

.svg-elem-9 {
  -webkit-animation: animate-svg-fill-9 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.6s  both infinite;
          animation: animate-svg-fill-9 3s cubic-bezier(0.6, 0.04, 0.98, 0.335) 1.6s  both infinite;
}

</style>